<template>
	<v-container grid-list-xl fluid>
		<v-layout row wrap>
			<v-flex md6 v-for="(reportGroup, index) in reportsGrouped" :key="index">
				<v-card>
					<v-list subheader>
						<v-subheader inset>{{ reportGroup[0].group }}</v-subheader>

						<v-list-tile v-for="report in reportGroup" :key="report.reportName" avatar @click="handleReportClick(report)">
							<v-list-tile-avatar>
								<v-icon class="blue white--text">{{ report.icon }}</v-icon>
							</v-list-tile-avatar>

							<v-list-tile-content>
								<v-list-tile-title>{{ report.friendlyName }}</v-list-tile-title>
								<v-list-tile-sub-title v-if="report.reportType === 'csv'">CSV Download</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action v-if="report.reportType === 'csv'">
								<v-icon color="grey lighten-1">mdi-download</v-icon>
							</v-list-tile-action>
						</v-list-tile>
					</v-list>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import Vue from 'vue';
	import ReportType from '@/enums/reportType';

	export default {
		props: {
			isAdmin: {
				type: Boolean,
				required: true
			},
			reports: {
				type: Array,
				required: true
			}
		},
		data() {
			return {};
		},
		computed: {
			reportsGrouped() {
				return _.groupBy(this.allowedReports, 'group');
			},
			allowedReports() {
				if (this.isAdmin) {
					return this.reports;
				} else {
					return this.reports.filter(x => x.roles == null);
				}
			}
		},
		methods: {
			async handleReportClick(report) {
				if (report.reportType === ReportType.WEB) {
					this.$router.push(`/report/${report.name}`);
				} else if (report.reportType === ReportType.CSV) {
					const tenantId = this.$store.state.tenantId;
					const url = `/api/${tenantId}/reports/${report.name}`;

					// Download CSV
					try {
						const response = await Vue.axios.get(url, {
							responseType: 'blob'
						});

						const blob = new Blob([response.data], { type: 'text/csv' });
						const link = document.createElement('a');
						link.href = window.URL.createObjectURL(blob);
						link.download = `${report.friendlyName.toLowerCase().replace(/ /g, '_')}.csv`;
						link.click();
					} catch (error) {
						console.error('Download failed', error);
						this.$toast.error('Failed to download report.');
					}
				}
			}
		}
	};
</script>

<style scoped>

</style>
